import {ReactComponent as IconPageTop} from "../assets/img/common/icon_pagetop.svg";

/**
 * ページトップへボタン
 */
const PageTopButton = () => {

    const handleClick = (e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();

        // スクロール
        const result = document.getElementById("header");
        window.scrollTo({
            top: result?.offsetTop,
            behavior: "smooth"
        });
    }

    return (
        <div className="l-footer-pagetop">
            <a href="#header" aria-label="ページ上部に戻る" onClick={handleClick}><IconPageTop width="16" height="16" /></a>
        </div>
    );
};

export default PageTopButton;